<template>
    <div class="o-sms-modal-otg-input-number">
        <span class="sms-modal-otg-title">
            {{ titleMessage }}
        </span>
        <span class="sms-modal-otg-label">
            {{ label }}
        </span>
        <div class="sms-modal-otg-wrapper">
            <AInput
                :value="formattedNumber"
                :placeholder="inputPlaceholder"
                :maxLength="16"
                :class="['sms-modal-otg-input', inputErrorCssClass]"
                disabled
            />
            <span
                v-if="errorMessage"
                class="sms-modal-otg-input-error-message"
            >
                {{ errorMessage }}
            </span>
        </div>
        <ONumbersKeyboard
            class="sms-modal-otg-keyboard"
            @onClick="onKeyboardClick"
        />
        <AButtonOtg
            :title="buttonTitle"
            :disabled="isSendSmsDisabled"
            class="sms-modal-otg-send-button"
            @onClick="validateNumber"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex';

import AInput from '../../atoms/a-input/a-input';
import AButtonOtg from '../../atoms/a-button-otg';
import ONumbersKeyboard from '../../organisms/o-numbers-keyboard';

import { TEL_NUMBER_REG_EXP } from '../o-sms-modal-standard/constsnts';
import { formatPhoneNumber } from "../o-sms-modal-otg/o-sms-modal-service";

export default {
    name: 'OSmsModalOtgInputNumber',
    components: {
        AInput,
        AButtonOtg,
        ONumbersKeyboard
    },
    props: {
        itemId: {
            type: Number,
            default: 0
        },
        itemName: {
            type: String,
            default: ''
        },
        terminalId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            phoneNumber: '',
            error: null,
            isLoading: false
        }
    },
    computed: {
        errorMessage() {
            return this.error ? this.$t('ui.invalid-number') : '';
        },
        inputErrorCssClass() {
            return this.errorMessage ? 'sms-modal-otg-input-error' : null;
        },
        titleMessage() {
            return this.$t('ui.modal.sms.title', { storename: this.itemName }, this.itemName);
        },
        label() {
            return this.$t('ui.enter-phone-number');
        },
        buttonTitle() {
            return this.$t('ui.send-link-by-sms');
        },
        isSendSmsDisabled() {
            return this.error || this.isLoading;
        },
        inputPlaceholder() {
            return this.$t('ui.input-phone-number-placeholder');
        },
        formattedNumber() {
            return formatPhoneNumber(this.phoneNumber);
        }
    },
    methods: {
        ...mapActions([
            'sendSmsV2'
        ]),
        onKeyboardClick(data) {
            this.error = null;
            if (data === '<') {
                this.removeValue();
            } else {
                this.phoneNumber = this.phoneNumber + data;
            }
        },
        removeValue() {
            if(this.phoneNumber.length > 0) {
                this.phoneNumber = this.phoneNumber.substring(0, this.phoneNumber.length - 1);
            }
        },
        validateNumber() {
            if(this.phoneNumber.match(TEL_NUMBER_REG_EXP)) {
                this.sendSms();
            }
            else {
                this.error = true;
            }
        },
        async sendSms() {
            this.isLoading = true;

            const params = {
                phone: this.phoneNumber,
                from:  this.terminalId,
                to: this.itemId,
                mode: this.$route.params.type,
            };

            try {
                await this.sendSmsV2(params);
                const successMessage = this.$t('ui.directions-sent-to', { phoneNumber: `*** ** ${this.phoneNumber.slice(-3)}`});

                this.$emit('smsSendSuccess', successMessage);
            } catch(error) {
                this.$emit('smsSendFail', error);
            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
